import React, { useEffect, useState, useRef } from 'react';
import BreadCrumbComponent from '../bread-crumb/BreadCrumbComponent';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../AppInsights';
import { withMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import Spinner from "../Spinner"
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';
import { MultiSelect } from 'primereact/multiselect';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { MessageSeverity } from 'primereact/api';
import { ReportService } from './ReportService';
import { ExportFileService } from '../../services/ExportFileService'
import { ProdItemSettingService } from '../prodItemSettings/ProdItemSettingSerivce'
import "./Report.css";

//HDO-7006 - Monitoring Tool - Interface Count Report - Implementation
function InterfaceCount(props) {
  const reportService = new ReportService();
  const exportFileService = new ExportFileService();
  const prodItemSettingService = new ProdItemSettingService();
  const alertMessage = useRef(null);
  const [hideSpinner, sethideSpinner] = useState(false);
  const [hieSystem, sethieSystem] = useState([]);
  const [instanceList, setInstanceList] = useState([]);
  const [namespaceList, setNamespaceList] = useState([]);
  const [interfaceCountData, setInterfaceCountData] = useState([]);
  const [pageErrorMessage, setpageErrorMessage] = useState(null)
  const [pageSuccessMessage, setpageSuccessMessage] = useState(null)
  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [searchRequest, setSearchRequest] = useState({
    'Instance': JSON.parse(sessionStorage.getItem("Instance")) ?? '',
    'NameSpace': JSON.parse(sessionStorage.getItem("NameSpace")) ?? '',
    'Businesstype': JSON.parse(sessionStorage.getItem("Businesstype")) ?? '',
    'SearchItem': JSON.parse(sessionStorage.getItem("SearchItem")) ?? ''
  })
  const [disableNameSpaceDropDown, setDisableNameSpaceDropDown] = useState(true)
  const [Businesstype, setBusinessType] = useState([
    { label: 'OPERATION', value: 'OPERATIONS' },
    { label: 'PROCESS', value: 'PROCESSES' },
    { label: 'SERVICE', value: 'SERVICES' }
  ])

  const [tooltipText, setTooltipText] = useState(<>123<br />2323<br /></>)

  useEffect(() => {
    getHIEInstances()
  }, [])

  const getHIEInstances = () => {
    setpageErrorMessage(null); setpageSuccessMessage(null)
    prodItemSettingService.getHIEInstances("CACHE", props.msalContext).then(
      (d) => {
        if (d.status === 403) {
          this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
        } else {
          let instance = []
          d.body.map((item) => (instance.push({ label: item.ServerInstance, value: item.ServerInstance })));
          setInstanceList(instance); sethieSystem(d.body); sethideSpinner(true); getProductions(['ALL']);
        }
      }
    ).catch(e => {
      console.log(e)
      setpageErrorMessage('Something went wrong !'); sethideSpinner(true);
    });
  }

  const getProductions = (instance) => {
    sethideSpinner(false); setpageErrorMessage(null); setpageSuccessMessage(null)
    prodItemSettingService.getProductions(instance, props.msalContext).then(
      (d) => {
        if (d.status === 403) {
          this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
        } else {
          let namespace = []
          d.body.map((item) => (namespace.push({ label: item.Namespace, value: item.Namespace })));
          setNamespaceList(namespace); sethideSpinner(true); loadInterfaceCountData(); setDisableNameSpaceDropDown(false);
        }
      }
    ).catch(e => {
      console.log(e)
      setpageErrorMessage('Something went wrong !'); sethideSpinner(true);
    });
  }

  const loadInterfaceCountData = () => {
    sethideSpinner(false);
    let instanceReq = searchRequest.Instance && searchRequest.Instance.length > 0 ? formatMultipleInputRequest(searchRequest.Instance) : ''
    let nameSpaceReq = searchRequest.NameSpace && searchRequest.NameSpace.length > 0 ? formatMultipleInputRequest(searchRequest.NameSpace) : ''
    let businesstypeReq = searchRequest.Businesstype && searchRequest.Businesstype.length > 0 ? formatMultipleInputRequest(searchRequest.Businesstype) : ''
    reportService.getInterfaceCount(instanceReq, nameSpaceReq, businesstypeReq, searchRequest.SearchItem, props.msalContext).then(response => {
      if (response && response.status === 200) {
        setInterfaceCountData(response.body)
        sethideSpinner(true)
      }
      else {
        sethideSpinner(true)
        setpageErrorMessage("Something went wrong !!!")
      }
    }).catch(e => {
      console.log(e)
      setpageErrorMessage('Something went wrong !'); sethideSpinner(true);
    })
  }

  const formatMultipleInputRequest = (value) => {
    let output = value.toString().split(',').map(item => `'${item}'`).join(',')
    return output
  }

  const exportInboundData = () => {
    setpageErrorMessage(null); setpageSuccessMessage(null)
    exportFileService.exportExcel(interfaceCountData, 'interface-count-report')
  }

  const globalSearchFilter = () => {
    return (
      <div>
        <div className="flex justify-content-between" >
          <span>
            <Button type="button" icon="pi pi-file-export" label="Export" className="p-button-success" tooltip='Export into excel' tooltipOptions={{ position: 'top' }} onClick={exportInboundData} />
          </span>
          <span className="p-input-icon-left">
            <i className="pi pi-search"></i>
            <InputText type="search" value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Global Search" style={{ width: '100%' }} size={100} />
          </span>
          <span>
            <Button tooltip='Refresh' tooltipOptions={{ position: 'top' }} onClick={(e) => loadInterfaceCountData()} icon="pi pi-refresh" />
          </span>
        </div>
      </div>
    )
  }

  const onGlobalFilterChange = (e) => {
    setpageErrorMessage(null); setpageSuccessMessage(null);

    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;

    setFilters(_filters); setGlobalFilterValue(value);
  }

  const handleMultiDropDownInputChange = (event) => {
    sessionStorage.setItem([event.target.name], JSON.stringify(event.value));
    setpageErrorMessage(null); setpageSuccessMessage(null);
    setSearchRequest(prev => ({
      ...prev,
      [event.target.name]: event.value
    }));
  }

  const handleInputChange = (event) => {
    sessionStorage.setItem([event.target.name], JSON.stringify(event.target.value));
    setpageErrorMessage(null); setpageSuccessMessage(null);
    setSearchRequest(prev => ({
      ...prev,
      [event.target.name]: event.target.value
    }));
  }

  const getCacheProductionUrl = (rowData) => {
    try {
      let url = '#'
      let system = hieSystem.find(x => x.ServerInstance === rowData.Instance)

      if (system !== null && system.OSVersion === "AIX") {
        if (system.Platform === 1 || system.Platform === 2) //1-HEALTHSHARE, 2-ENSEMBLE
          url = `https://${rowData.Instance.toLocaleLowerCase()}.nshs.edu/csp/healthshare/${rowData.NameSpace.toLocaleLowerCase()}/EnsPortal.ProductionConfig.zen?NAMESPACE=${rowData.NameSpace}`;
        else
          url = `https://${rowData.Server.toLocaleLowerCase()}.nshs.edu/${rowData.Instance.toLocaleLowerCase()}/csp/${rowData.NameSpace.toLocaleLowerCase()}/EnsPortal.ProductionConfig.zen?NAMESPACE=${rowData.NameSpace}`;
      }
      else if (system.OSVersion === "LINUX") { //HM-1149 - fix
        url = `https://${rowData.Instance.toLocaleLowerCase()}.mid.northwell.edu/csp/healthshare/${rowData.NameSpace.toLocaleLowerCase()}/EnsPortal.ProductionConfig.zen?NAMESPACE=${rowData.NameSpace}`;
      }
      return <a href={url} target="_blank">{rowData.NameSpace}</a>;
    }
    catch (error) {
      console.log(error)
    }
  }

  const clearSearchParams = () => {
    setSearchRequest({
      'Instance': '',
      'NameSpace': '',
      'Businesstype': '',
      'SearchItem': ''
    });
    setpageErrorMessage(null); setpageSuccessMessage(null);
    setFilters({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    })
    setGlobalFilterValue('');
    sessionStorage.clear();
  }

  const showError = (severity, summary, msg) => {
    alertMessage.current.show({ severity: severity, summary: summary, detail: msg, life: global.ALERT_MSG_LIFE });
  }

  const tooltipItems = [
    "TotalCount: Represents the total number of interfaces.",
    "SearchCount: Represents the number of interfaces that match the search item criteria.",
    "ItemCount: TotalCount - SearchCount."
  ];

  // Join items with <br /> for line breaks in the tooltip
  const tooltipContent = tooltipItems.join('\n');

  return (

    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
      <div>
        <BreadCrumbComponent {...props} />
        <Toast ref={alertMessage} />
        {pageErrorMessage ? showError(MessageSeverity.ERROR, 'Error Message', pageErrorMessage) : <></>}
        {pageSuccessMessage ? showError(MessageSeverity.SUCCESS, 'Success Message', pageSuccessMessage) : <></>}

        <div hidden={hideSpinner}>
          <Spinner />
        </div>

        <header className="page-header">
          <div className="page-header-title">INTERFACE COUNT REPORT
            &nbsp;<Tooltip target=".custom-target-icon" content={tooltipContent} />
            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
              style={{ fontSize: '1rem', cursor: 'pointer' }}>
            </i>
          </div>
        </header>

        <div className="card">
          <div className="float-container">
            <div className="float-child">
              <MultiSelect options={instanceList} value={searchRequest.Instance} name='Instance'
                filter onChange={(e) => handleMultiDropDownInputChange(e)} maxSelectedLabels={1} placeholder="Select Instance" className="multiselect-custom"
              />
            </div>
            <div className="float-child">
              <MultiSelect disabled={disableNameSpaceDropDown} options={namespaceList} value={searchRequest.NameSpace} name='NameSpace'
                filter onChange={(e) => handleMultiDropDownInputChange(e)} maxSelectedLabels={1} placeholder="Select NameSpace" className="multiselect-custom"
              />
            </div>
            <div className="float-child">
              <MultiSelect options={Businesstype} value={searchRequest.Businesstype} name='Businesstype'
                filter onChange={(e) => handleMultiDropDownInputChange(e)} maxSelectedLabels={1} placeholder="Select Businesstype" className="multiselect-custom"
              />
            </div>
            <div className="float-child">
              <InputText type='text' placeholder='Search item' name='SearchItem' value={searchRequest.SearchItem} onChange={handleInputChange} />
            </div>
            <div className="float-child">
              <Button label='Search' onClick={(e) => loadInterfaceCountData()} />
            </div>
            <div className="float-child">
              <Button label='Clear' onClick={clearSearchParams} />
            </div>
          </div>
        </div>
        <br />
        {interfaceCountData && interfaceCountData.length > 0 ?
          <>
            <div className="card">
              <div className="float-container">
                <h6><i>Sum of TotalCount - {interfaceCountData.reduce((sum, item) => sum + item.TotalCount, 0)} ,
                  SearchCount - {interfaceCountData.reduce((sum, item) => sum + item.SearchCount, 0)} ,
                  ItemCount - {interfaceCountData.reduce((sum, item) => sum + item.ItemCount, 0)}</i></h6>
              </div>
            </div>  <br />
          </>
          : <></>}

        <DataTable value={interfaceCountData}
          dataKey="Id"
          paginator={true}
          rows={10}
          rowsPerPageOptions={[10, 20, 50, 100]}
          selectionMode="single"
          responsiveLayout="scroll"
          responsive={true}
          emptyMessage="No Records found."
          showGridlines={true}
          filters={filters}
          header={globalSearchFilter}
          stateStorage="session" stateKey="dt-interfacecount-session"
        >
          <Column field="Instance" header="Instance" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} />
          <Column field="NameSpace" header="Namespace" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} body={getCacheProductionUrl} />
          <Column field="TotalCount" header="Total Count" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} sortable />
          <Column field="SearchCount" header="Search Count" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} sortable />
          <Column field="ItemCount" header="Item Count" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} sortable />
        </DataTable> <br />
      </div>
    </MsalAuthenticationTemplate>
  );
}

const WrappedInterfaceCount = withMsal(InterfaceCount);
export default withAITracking(reactPlugin, WrappedInterfaceCount);